



















































































import ModalTabMixin from '@/mixins/modal-tab.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { IPropertyRoomType } from '@resclick/data-access';
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import RoomTypesSingleTab from './room-types-single.tab.vue';

const roomTypeModel = (): IPropertyRoomType => {
  return {
    privateUse: false,
    layout: 'SINGLE',
    type: '',
    class: undefined,
    view: undefined,
    label: '',
    featuredAmenity: undefined,
    areaType: undefined,
    numberOfBedrooms: 0,
    smokingPreference: 'IN_SOME_ROOMS',
    wheelchairAccess: false,
    nameParts: {
      class: false,
      view: false,
      areaType: false,
      featuredAmenity: false,
      accessibility: false,
      smokingPreference: false,
    },
    bedConfigs: [],
    extraBed: undefined,
    occupancy: {
      total: 1,
      minAdults: 1,
      maxAdults: 1,
      minChildren: 0,
      maxChildren: 0,
    },
    amenities: {
      layout: {
        roomSize: 0,
        roomSizeUnit: 'SQUARE_METER',
        separateDiningArea: false,
        separateSittingArea: false,
        sharedAccommodations: false,
        desk: false,
        laptopFriendlyWorkspace: false,
        fireplace: false,
        heatedFloors: false,
        accessViaExteriorCorridors: false,
        privatePool: false,
        privatePlungePool: false,
        privateSpaTub: false,
        outdoorSpaces: '',
        individuallyDecorated: false,
        individuallyFurnished: false,
        connectingRoomsAvailable: false,
        yard: false,
        noWindows: false,
        inRoomPlaypen: false,
      },
      bathroom: {
        primaryBathroom: 'PRIVATE_BATHROOM',
        numberOfBathrooms: 0,
        bathrobes: false,
        childrenBathrobes: false,
        heatedFloor: false,
        freeToiletries: false,
        designerToiletries: false,
        soap: false,
        shampoo: false,
        toiletPaper: false,
        hairDryer: false,
        bidet: false,
        bathType: 'SHOWER',
        bathtubType: 'STANDARD_BATHTUB',
        hydroMassageShowerhead: false,
        rainfallShowerhead: false,
      },
      bedding: {
        hypoAllergenicBedding: false,
        premiumBedding: false,
        premiumLinenType: 'EGYPTIAN_COTTON_SHEETS',
        premiumMattressType: '',
        pillowMenu: false,
        downComforter: false,
      },
      accessibility: {
        accessibleBathroom: false,
        rollInShower: false,
        inRoomAccessibility: false,
        availableInGuestrooms: false,
        transferShower: false,
        accessibleBathtub: false,
        portableBathtubSeat: false,
        bathroomGrabBars: false,
        raisedToiletSeat: false,
        visualFireAlarm: false,
        doorbellTelephoneNotification: false,
        vibratingPillowAlarm: false,
        leverDoorHandles: false,
        wheelchairWidthDoorways: false,
        heightAdjustedAmenities: false,
        telephoneAccessibilityKit: false,
      },
      kitchen: {
        available: false,
        type: 'KITCHEN',
        cookwareDishwareUtensils: false,
        dishwasher: false,
        refrigerator: false,
        refrigeratorType: 'REFRIGERATOR',
        oven: false,
        microwave: false,
        microwaveType: 'MICROWAVE',
        riceCooker: false,
        stovetop: false,
        minibar: false,
        minibarType: 'MINIBAR',
      },
      inRoomRefreshment: {
        freeBottledWater: false,
        coffeeTeaMaker: false,
        espressoMaker: false,
        electricKettle: false,
      },
      inRoomEntertainment: {
        television: false,
        televisionType: 'TELEVISION',
        televisionSize: 0,
        dvdPlayer: false,
        iPodDocStation: false,
        mp3DocStation: false,
        videoGameConsole: false,
        computerOrTablet: false,
        computerType: 'COMPUTER',
        channels: [],
      },
      climateControl: {
        airConditioning: false,
        airConditioningType: 'AIR_CONDITIONING',
        fan: false,
        ceilingFan: false,
        portableFan: false,
        heating: false,
        heatingType: 'HEATING',
      },
    },
  } as any;
};

@Component({
  components: {
    RoomTypesSingleTab,
  },
})
export default class TabRoomType extends Mixins(ModalTabMixin) {
  @Prop() id!: string;

  showAlertDialog = false;
  nextAction: any;
  roomSearchField = '';
  currentRoomIndex: number | undefined = 0;
  roomTypeForms: CrsForm<'properties', 'createRoomType' | 'updateRoomType'>[] = [];

  get currentForm() {
    return this.roomTypeForms[this.currentRoomIndex || 0];
  }

  get currentRoomType() {
    const currentForm = this.currentForm || { fields: {} };
    return currentForm.fields;
  }

  changeRoomType(i: number, nextAction?: any) {
    if (i === this.currentRoomIndex) return;
    if (this.currentForm && this.currentForm.hasChanges && this.currentForm.hasChanges()) {
      this.showAlertDialog = true;
      this.nextAction = () => {
        if (typeof nextAction === 'function') nextAction();
        this.currentRoomIndex = i;
      };
    } else {
      if (typeof nextAction === 'function') nextAction();
      this.currentRoomIndex = i;
      this.roomTypeForms[i].reset();
    }
  }

  alertSave() {
    this.onSubmit({
      propertyId: this.id,
      roomTypeId: (this.currentRoomType as any).id,
    }).then(() => this.nextAction());
  }

  alertDiscardChanges() {
    this.currentForm.reset();
    this.nextAction();
  }

  onUpdateRoomType(index: number, value: IPropertyRoomType) {
    this.$set(this.roomTypeForms, index, value);
  }

  addRoomType() {
    if (this.roomTypeForms.length < 1) {
      this.roomTypeForms.push(this.$crsForm('properties', 'createRoomType', roomTypeModel() as any));
      this.changeRoomType(0);
    } else {
      this.changeRoomType(this.roomTypeForms.length, () => {
        this.roomTypeForms.push(this.$crsForm('properties', 'createRoomType', roomTypeModel() as any));
      });
    }
  }

  @Watch('currentRoomIndex')
  setCurrentForm(value: number) {
    this.form = this.roomTypeForms[value];
  }

  created() {
    this.loading = true;

    compass
      .do('properties', 'findRoomTypes', {
        params: { propertyId: this.id || '' },
        limit: 100,
      })
      .then(({ data }) => {
        this.roomTypeForms = data.map((roomType) => this.$crsForm('properties', 'updateRoomType', roomType as any));
        if (this.roomTypeForms.length > 0) this.currentRoomIndex = 0;
      })
      .finally(() => {
        this.loading = false;
      });

    this.$on('update-data', ({ data, index }: { data: IPropertyRoomType; index: number }) => {
      compass
        .do('properties', 'findOneRoomType', {
          params: {
            propertyId: this.id,
            roomTypeId: data.id,
          },
        })
        .then((res) => {
          this.roomTypeForms.splice(index, 1, this.$crsForm('properties', 'updateRoomType', res.data as any));
          this.setCurrentForm(this.currentRoomIndex as number);
        });
    });
  }

  async onSubmit(params?: any) {
    const index = this.currentRoomIndex;
    this.loading = true;
    if (typeof index === 'number') {
      return this.roomTypeForms[index]
        .submit({ params })
        .then((res) => this.$emit('update-data', { data: res.data, index }))
        .finally(() => (this.loading = false));
    }

    return this;
  }
}
